export default __webpack_public_path__ + "static/media/banner-programa-de-compliance-01.933f8e6b.png";